import type { ReactNode } from "react";
import { Link } from "react-router-dom";

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  linkTo?: string;
  linkLabel?: string;
  action?: ReactNode;
}

export default function SectionHeading({
  eyebrow,
  title,
  description,
  linkTo,
  linkLabel,
  action,
}: SectionHeadingProps) {
  return (
    <div className="mb-6 flex flex-wrap items-end justify-between gap-4">
      <div>
        {eyebrow && (
          <span className="flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-accent-600">
            <span className="h-1 w-6 rounded-full bg-accent-500" />
            {eyebrow}
          </span>
        )}
        <h2 className="mt-2 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
          {title}
        </h2>
        {description && (
          <p className="mt-1.5 max-w-2xl text-sm text-foreground-500">{description}</p>
        )}
      </div>
      {action}
      {linkTo && linkLabel && (
        <Link
          to={linkTo}
          className="flex whitespace-nowrap items-center gap-1 text-sm font-semibold text-primary-600 transition-colors hover:text-primary-700"
        >
          {linkLabel}
          <i className="ri-arrow-right-s-line text-base" />
        </Link>
      )}
    </div>
  );
}